const sourceMap = new Map([
    ['ONLINE', 'Online'],
    ['POSTAL', 'Postal'],
]);

export const caseSourceMapper = (value) => {
    return sourceMap.get(value) ?? 'Unknown';
}